import { bus, helper } from '../../utils'
import NotificationsCreate from '../NotificationsCreate/NotificationsCreate.vue'
import NotificationsDelete from '../NotificationsDelete/NotificationsDelete.vue'
import NotificationsEdit from '../NotificationsEdit/NotificationsEdit.vue'

export default {
  beforeDestroy () {
    bus.$off('get-notifications-list')
  },
  components: {
    NotificationsCreate,
    NotificationsDelete,
    NotificationsEdit
  },
  computed: {
    canAddNotification () {
      return this.limitRules
    },
    componentTitle () {
      return this.$t(`ComponentTitle.${this.$route.name}`)
    },
    defaultSort () {
      return { prop: 'rule', order: 'descending' }
    },
    isRulesLimitReached () {
      return this.ownRules >= this.limitRules
    },
    noQuotaBlockShows () {
      return this.limitRules <= 0
    }
  },
  methods: {
    editNotification (id) {
      bus.$emit('show-edit-notification', {
        show: true,
        id
      })
    },
    delNotification (id) {
      bus.$emit('show-delete-notification', {
        show: true,
        id
      })
    },
    getFamilyMembers (models = {}) {
      return Object.keys(models).reduce((acc, curr) => Object.assign(acc, { [curr]: models[curr].informationModel.familyMembers || [] }), {})
    },
    getFamilyNames (models = {}) {
      return Object.keys(models).map(model => model)
    },
    async getNotificationsList () {
      this.loading = true

      const themeData = await this.$api.getTheme()
      .then(({ data }) => data)
      .catch(error => console.error(error))

      return Promise.all([
        this.$api.getNotificationsList(),
        this.$api.getInfoModels()
      ])
        .then(([rules, models]) => {
          const list = rules.map(({
            actions,
            event: { conditions },
            familyName,
            id
          }) => {
            return actions.map((action) => {
              const familyNames = familyName.join(', ')
              const { title, body: message } = action
              const newConditions = conditions.map((condition) => {
                const { key, op, target } = condition
                const operation = this.getOperation(op)
                return `${key} ${operation} ${target}`
              })

              return {
                familyNames,
                id,
                message,
                rule: newConditions.join(', '),
                title
              }
            })
          })
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), [])

          this.limitRules = themeData.notification_rule_limit
          this.familyNames = this.getFamilyNames(models.data)
          this.familyMembers = this.getFamilyMembers(models.data)
          this.notificationsList = list
          this.ownRules = list.length
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.limitRules = status === 405 ? 0 : themeData.notification_rule_limit

          helper.showErrorMessage(this, this.component, error)
        })
    },
    getOperation (op) {
      if (!op) { throw new Error('Operation is required.') }

      const operators = {
        eq: '=',
        gt: '>',
        geq: '≥',
        lt: '<',
        leq: '≤',
        neq: '≠'
      }

      if (!operators[op]) {
        throw new Error('No matched operation found.')
      }
      return operators[op]
    },
    getRecipients (recipients) {
      const hasOwner = recipients && Array.isArray(recipients) && recipients.includes('owner')
      const hasGuest = recipients && Array.isArray(recipients) && recipients.includes('guest')

      if (hasOwner && hasGuest) {
        return 'All'
      } else if (hasOwner) {
        return 'Owner'
      }
      return '--'
    },
    showAddNotification () {
      bus.$emit('show-add-notification', true)
    }
  },
  name: 'Notifications',
  created () {
    const uid = window.localStorage.getItem('uid')
    this.uid = uid ? +uid : null

    bus.$on('get-notifications-list', () => {
      this.getNotificationsList()
    })
  },
  data () {
    return {
      component: 'notifications',
      familyMembers: {},
      familyNames: [],
      ownRules: 0,
      notificationsList: [],
      limitRules: 10,
      loading: true,
      showDeletePopup: false,
      showModal: false,
      uid: null
    }
  },
  mounted () {
    this.getNotificationsList()
  }
}



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.js